import PropTypes from "prop-types";
import "@css/MenuSkeleton.css";

/**
 * MenuSkeleton - компонент-заглушка меню с анимацией загрузки
 * Отображает скелет меню с 5 кнопками слева и 2 справа
 * Используется в FullPageLoader для имитации структуры Header
 */
const MenuSkeleton = ({ leftItemCount = 5, rightItemCount = 2 }) => {
    return (
        <div className="menu-skeleton">
            <div className="menu-skeleton-container">
                {/* Логотип/гамбургер */}
                
                {/* Пункты меню слева */}
                <div className="menu-skeleton-items-left">
                    {Array.from({ length: leftItemCount }).map((_, index) => (
                        <div
                            key={`left-${index}`}
                            className="menu-skeleton-item"
                        />
                    ))}
                </div>

                {/* Пункты меню справа */}
                <div className="menu-skeleton-items-right">
                    {Array.from({ length: rightItemCount }).map((_, index) => (
                        <div
                            key={`right-${index}`}
                            className="menu-skeleton-item"
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

MenuSkeleton.propTypes = {
    leftItemCount: PropTypes.number,
    rightItemCount: PropTypes.number,
};

export default MenuSkeleton;
